import { getUTCNow } from '@epicuro-next/utilities';

import { isNowDateContainer } from './now-date-container/is-now-date-container';

export const unpackNowDate = (deliveryDate: string) => {
  return isNowDateContainer(deliveryDate) ? getUTCNow() : deliveryDate;
};
